import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCheckboxModule, MatDialogModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { FcOutlinedInputModule } from '@core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { TreeViewModule } from '@core/components/fc-tree-view/fc-tree-view.module';
import { TreeViewService } from '@core/components/fc-tree-view/fc-tree-view.service';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TabLinksService } from '../tab-links.service';
import { DialogLinkComponent } from './dialog-link.component';
import { DialogLinkService } from './dialog-link.service';

@NgModule({
  entryComponents: [
    DialogLinkComponent
  ],
  declarations: [
    DialogLinkComponent
  ],
  imports: [
    FuseSharedModule,
    FcOutlinedInputModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    TreeViewModule,
  ],
  providers: [
    TreeViewService,
    TabLinksService,
    DialogLinkService
  ],
  exports: [
    DialogLinkComponent
  ]
})
export class DialogLinkModule {}
